import { orderMessagesUrl } from '../resources.js'
//import { HubConnectionBuilder, HttpTransportType } from '@aspnet/signalr'
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
var hubConnection = null;
var isConnected = false;

//
//Establish a hub to connect to server
//
function createHubConnection(token) {
    hubConnection = new HubConnectionBuilder() 
                            .withUrl(orderMessagesUrl, {
                                skipNegotiation: true,
                                transport: HttpTransportType.WebSockets,
                                accessTokenFactory: () => token
                            })
                            .withAutomaticReconnect()
                            .build();
}

//
//Connect to server
//
async function connectToServer() {
    let count = 0;
    while (!isConnected && count < 5 ) {
        await setTimeout( () => { console.log('Connecting...') }, 100*1000000 );
        count++;
        await hubConnection.start()
             .then(() => {
                    console.log('Connection Started');
                    isConnected = true; })
             .catch((err) => {
                    console.log('Cannot connect to server!');
                    console.log(err);
                });
    }
    return isConnected;
    
}

//
//Listening for specific method that the server will send to client
//
async function registerToServerEvent(serverevent, invokedFunction ) {
    if (isConnected) {
        await hubConnection.on(serverevent, 
            (msg) => { invokedFunction(msg) }); 
    }
    
}

//
//Register to group: Each restaurant is a group that restaurant owner and restaurant manager
//must register to to receive order messages from customer
//
async function registerToGroup(restaurantid) {
    if (isConnected) {
        await hubConnection.invoke('AddToGroup', restaurantid)
                            .then(console.log('Client is registered to group'))
                            .catch(err => console.log(err));
    }
    
    
}

async function unregisterFromGroup(restaurantid) {
    if (isConnected) {
        await hubConnection.invoke('RemoveFromGroup', restaurantid)
                            .then(console.log('Client is unregistered to group'))
                            .catch(err => console.log(err));
    }
    
}

function onReconnected(callback) {
    hubConnection.onreconnected( err => { 
        console.log('Hub is reconneted!'); 
        callback();
    });
}

function onReconnecting(callback) {
    hubConnection.onreconnecting(msg => {
        console.log('Hub is reconnecting...'); 
        callback();
    })
}

function onClose(callback) {
    hubConnection.onclose( err => { 
        console.log('Hub is closed!!!');
        callback();
     });
}


export default {
    name: 'ordermessages',
    hubConnection,
    createHubConnection,
    connectToServer,
    registerToServerEvent,
    registerToGroup,
    unregisterFromGroup,
    onReconnected,
    onReconnecting,
    onClose
} 